import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(3),
    boxSizing: 'border-box',
  },
  card: {
    width: '100%',
    maxWidth: '520px',
    textAlign: 'center',
  },
  title: {
    margin: theme.spacing(0, 0, 1.5, 0),
  },
  description: {
    margin: 0,
  },
}), { name: 'UnauthorizedPage' });

interface UnauthorizedPageProps {
  fullHeight?: boolean;
}

export default function UnauthorizedPage (props:UnauthorizedPageProps) {
  const { fullHeight = true } = props;
  const classes = useStyles();

  return (
    <div
      className={classes.root}
      style={fullHeight ? undefined : { minHeight: '100%' }}
    >
      <div className={classes.card}>
        <h2 className={classes.title}>Unauthorized</h2>
        <p className={classes.description}>You are not authorized to access this page.</p>
      </div>
    </div>
  );
}
